export const SWIPER_YEAR_IMG = [
  require('../assets/year/slide1.png'),
  require('../assets/year/slide2.png'),
  require('../assets/year/slide3.png'),
  require('../assets/year/slide4.png'),
  require('../assets/year/slide5.png'),
  require('../assets/year/slide6.png'),
  require('../assets/year/slide7.png'),
  require('../assets/year/slide8.png')
]

export const SWIPER_TREA_IMG = [
  require('../assets/trea/slide1.png'),
  require('../assets/trea/slide2.png'),
  require('../assets/trea/slide3.png'),
  require('../assets/trea/slide4.png')
]

export const CONTRACTS = {
  facebook: "https://www.messenger.com/t/105658637584827",
  telegram: "https://t.me/CSKH888b"
}

export const FORM_VALID_MESSAGE = {
  loginFailTitle: "ĐĂNG NHẬP THẤT BẠI",
  registerFailTitle: "ĐĂNG KÝ THẤT BẠI",
  emptyMsg: "* Vui lòng điền đầy đủ thông tin.",
  usernameFormatErr: "* Tên đăng nhập phải từ 4 đến 20 kí tự.",
  passwordMsg: "* Mật khẩu phải từ 6 đến 15 kí tự.",
  phoneInvalid: "Định dạng phone chưa chính xác",
  phoneEmpty:"Điền SĐT chính chủ để nhận ưu đãi",
  emailInvalid: "Email không đúng định dạng.",
  emailFormatErr: "* Chỉ chấp nhận email @gmail.com ,@yahoo.com .",
  loggedTitle: "ĐĂNG NHẬP THÀNH CÔNG",
  loggedMsg: "* Bạn đang được chuyển về trang chủ 888b Vui lòng chờ trong 5s.",
  registerTitle: "ĐĂNG KÝ THÀNH CÔNG",
  registerMsg: "* Chúc mừng Bạn đã đăng nhập thành công! Tự động đăng nhập trong 5s."
}

export const DOMAIN_INVITE_CODE = {
  "ads23.win888b.com": "1rsn",
  "tien8666.vip": "30ca",
  "nohuto888.vip": "30ca",
  "vuixoso.com": "e721",
  "fb888b.com": "72e5",
  "dap-hu.online": "677b",
  "vip.noto888.vip": "ecf1",
  "hot.noto888.vip": "ecf1",
  "km.noto888.vip": "ecf1",
  "qc.noto888.vip": "ecf1",
  "vip.ta888b.com": "c9f9",
  "hot.ta888b.com": "c9f9",
  "km.ta888b.com": "c9f9",
  "hot.sl888b.com": "677b",
  "km.sl888b.com": "677b",
  "qc.sl888b.com": "677b",
  "vip.sl888b.com": "677b",
  "site.sl888b.com": "677b",
  "ld888b.com": "f9b9",
  "probet68.com": "677b",
  "sl888b.com": "677b",
  "banca888b.com": "2737",
  "ta888b.com": "c9f9",
  "qc.km8888b.com": "be9f",
  "km2888b.com": "uv8c",
  "km3888b.com": "3qxy",
  "noto888.vip": "ecf1",
  "38b8876.vip": "41ca",
  "loc.win888bwiner.top": "c875",
  "free.win888bwiner.top": "28a8",
  "mayman888.vip": "72e5",
  "thang888.vip": "e67e",
  "888b.life": "72E5",
  "quayrulet.com": "30ca",
  "cannhantai247.com": "be9f",
  "888bminigame.com": "7821",
  "quay-rulet.info": "62ef",
  "km0888b.com": "e67e",
  "bancavip888b.com": "30ca",
  "miencuclac.xyz": "72e5",
  "hot.vi888b.com": "1c98",
  "ads01.win888b.com": "2737",

  "ads02.win888b.com": "0383",
  "ads03.win888b.com": "0160",

  "ads04.win888b.com": "63ca",
  "ads05.win888b.com": "328b",
  "ads06.win888b.com": "e7b5",
  "ads07.win888b.com": "c75a",
  "ads08.win888b.com": "4bff",
  "ads09.win888b.com": "a9b6",
  "ads10.win888b.com": "6d9d",
  "ads11.win888b.com": "3951",
  "ads12.win888b.com": "2c2f",
  "ads13.win888b.com": "7124",
  "ads14.win888b.com": "9b7e",
  "ads15.win888b.com": "b251",
  "ads16.win888b.com": "658e",
  "ads17.win888b.com": "64zi",

  "ads21.win888b.com": "ahrz",
  "ads22.win888b.com": "6iom",

  "ads25.win888b.com": "cw4b",

  "ads26.win888b.com": "83ur",

  "ads27.win888b.com": "lgb0",
  "ads28.win888b.com": "jynx",

  "bancamap888.vip": "0923",
  "km.bancamap888.vip": "0923",
  "cm.bancamap888.vip": "0923",
  "hot.bancamap888.vip": "0923",
  "8886688.vip": "a18a",
  "anto8866.vip": "e721",
  "km7888b.com": "e543",
  "si888b.com": "9a94",
  "vi888b.com": "0923",
  "banca888b.club": "72e5",
  "nohu888b.club": "72e5",
  "bong888b.club": "72e5",
  "thethao888b.club": "72e5",
  "gamebai888b.club": "72e5",
  "888b.world": "7821",
  "loc.km8888b.com": "be9f",
  "win888bwiner.top": "mnj9",
  "xs.888b.world": "7821",
  "l0t0.888b.world": "7821",
  "sanca.888b.world": "7821",
  "l0de.888b.world": "7821",
  "locla.888b.world": "7821",
  "go888b.com": "e67e",
  "mienphi.win888bwiner.top": "mnj9",
  "km.win888bwiner.top": "mnj9",
  "hot.si888b.com": "9a94",
  "site.si888b.com": "9a94",
  "km.si888b.com": "9a94",
  "site.go888b.com": "e67e",
  "vip.go888b.com": "e67e",
  "hot.go888b.com": "e67e",
  "hot.mayman888.vip": "72e5",
  "vip.mayman888.vip": "72e5",
  "km.mayman888.vip": "72e5",
  "vebo.888bvn.vip": "30ca",
  "vip.8886688.vip": "a18a",
  "km.8886688.vip": "a18a",
  "qc.8886688.vip": "a18a",
  "hot.8886688.vip": "a18a",
  "cm.8886688.vip": "a18a",
  "xs.888bvn.vip": "30ca",
  "tanthu.888bvn.vip": "30ca",
  "khuyenmai.888bvn.vip": "30ca",
  "nhanloc.888bvn.vip": "30ca",
  "hot.888bvn.vip": "30ca",
  "km.888bvn.vip": "30ca",
  "phatloc.888bvn.vip": "30ca",
  "tangloc.888bvn.vip": "30ca",
  "thuongloc.888bvn.vip": "30ca",
  "ns888b.com": "30ca",
  "mphi.888bvn.vip": "30ca",
  "km.anto8866.vip": "e721",
  "hot.anto8866.vip": "e721",
  "vip.anto8866.vip": "e721",
  "qc.anto8866.vip": "e721",
  "bongda888b.com": "jynx",
  "c0de.buotnao.xyz": "0d1a",
  "xaloc.buotnao.xyz": "0d1a",
  "choi.buotnao.xyz": "0d1a",
  "loc.soi-kau.live": "0d1a",
  "vui.soi-kau.live": "0d1a",
  "test.soi-kau.live": "0d1a",
  "tanthu.dl38b17.club": "c9f9",
  "km.dl38b17.club": "c9f9",
  "banca.dl38b17.club": "c9f9",
  "dl38b17.club": "c9f9",
  "888b88.net": "2yrwe",
  "vn888b.com": "jeybp",
  "888b.earth": "7yyg3",

  "vuimung.888b.world": "7821",
  "cm.888b.world": "7821",
  "tanthu.8bgame.club": "9a94",
  "km.vip8b.today": "bf50",
  "tanthu.vip8b.today": "bf50",
  "locla.vip8b.today": "bf50",
  "tangqua.tanthu.xyz": "c91d",
  "locla.tanthu.xyz": "c91d",
  "km.tanthu.xyz": "c91d",
  "tanthu.888b.bid": "c7lyi",
  "mayman.888b.bid": "c7lyi",
};

export const DOMAIN_AGENT_LINE = {
  "ads25.win888b.com": 'vnc_ba25',
  "ads26.win888b.com": 'vnc_ba26',
  "ads27.win888b.com": 'vnc_ba27',
  "ads28.win888b.com": 'vnc_ba28'
}

/**
 * google gtag
 */
export const DOMAIN_GOOGLE_GTAG = {
  "hot.mayman888.vip": "G-3829W77MZC",
  "loc.km8888b.com": "G-XS6WDBXR3N",
  "bongda888b.com": "G-QEC2N4SSJS",
  "vip.8886688.vip": "UA-242791887-1",
  "km.anto8866.vip": "G-5872SLTPWS",
  "ads02.win888b.com": "G-9EGDS5806F",
  "ads03.win888b.com": "G-V22K65LVEY",
  "app2.888b.reisen": "G-M5EP5811BW"
}

export const PHONES_PREFIX_REPLACE = {
  "0162":	"032",
  "0163":	"033",
  "0164":	"034",
  "0165":	"035",
  "0166":	"036",
  "0167":	"037",
  "0168":	"038",
  "0169":	"039",
  "0120":	"070",
  "0121":	"079",
  "0122":	"072",
  "0126":	"076",
  "0128":	"078",
  "0123":	"083",
  "0124":	"084",
  "0125":	"085",
  "0127":	"081",
  "0129":	"082",
  "0182":	"052",
  "0186":	"056",
  "0188":	"058",
  "0199":	"059"
}

export const PHONES_PREFIX_FORE = ['0162','0163','0164','0165','0166','0167','0168','0169','0120','0121','0122','0126','0128','0123','0124','0125','0127','0129','0182','0186','0188','0199']

export const PHONES_PREFIX_THREE = ['086','096','097','098','032','033','034','035','036','037','038','039','070','079','072','076','078','089','090','093','077','088','091','094','083','084','085','081','082','092','052','056','058','019','059','099','095','043','087']



export const METATAGMAP = {
  "app2.888b.reisen": {name:`google-site-verification`,content:`n5dU-NOZXWST1eBmxJl8KAaiNUaTQ0UFcMM3qwU4kXQ`}
};



// WEBPACK FOOTER //
// ./src/utils/constant.js